module.exports = __webpack_public_path__ + "img/337.8c684ea6.png";